import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Stars, Tooltip } from 'components';
import FBSprite from './FBSprite';
import * as styles from './FBHeader.scss';
var FBHeader = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(FBHeader, _Component);

  var _super = _createSuper(FBHeader);

  function FBHeader() {
    _classCallCheck(this, FBHeader);

    return _super.apply(this, arguments);
  }

  _createClass(FBHeader, [{
    key: "render",
    value: function render() {
      var fbInfo = this.props.account || this.props.organization.SocialAccounts.find(function (sa) {
        return sa.platform === 'Facebook page';
      });
      var _this$props = this.props,
          avatarUrl = _this$props.avatarUrl,
          dateText = _this$props.dateText,
          pageName = _this$props.pageName;
      var backgroundImage = 'url(https://s3.amazonaws.com/likeabucket/user_upload/232/gWKDnZjH4.jpeg)';

      if (this.props.groupPost) {
        backgroundImage = backgroundImage;
      } else if (avatarUrl) {
        backgroundImage = "url(".concat(avatarUrl, ")");
      } else if (fbInfo && fbInfo.avatarImageUrl) {
        backgroundImage = "url(".concat(fbInfo.avatarImageUrl, ")");
      }

      var username = /*#__PURE__*/React.createElement("span", {
        className: styles.headerPageName
      }, "Username ", /*#__PURE__*/React.createElement(Tooltip, {
        name: "missing_facebook_account",
        message: "You do not have a Facebook account connected."
      }));

      if (this.props.groupPost) {
        username = 'Username';
      } else if (pageName) {
        username = pageName;
      } else if (fbInfo) {
        username = fbInfo.username;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.headerLogo,
        style: {
          backgroundImage: backgroundImage
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.headerText
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.headerPageName
      }, username, this.props.rating || this.props.reviewType ? /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#616770'
        }
      }, ' ', this.props.reviewType && this.props.reviewType === 'positive' ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FBSprite, {
        style: {
          display: 'inline-block'
        },
        name: "review-positive"
      }), " recommends") : 'reviewed', ' ', /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#385898'
        }
      }, this.props.ratingSubject)) : ''), /*#__PURE__*/React.createElement("div", {
        className: styles.headerSponsored
      }, moment.isMoment(dateText) ? dateText.format('MMMM D') : dateText, /*#__PURE__*/React.createElement("span", {
        className: styles.bullet
      }, "\u2022"), /*#__PURE__*/React.createElement("i", {
        className: "icon ion-earth ".concat(styles.earthIcon)
      }))), this.props.rating && /*#__PURE__*/React.createElement(Stars, {
        fontSize: 16,
        value: this.props.rating,
        color: "rgb(64, 128, 255)"
      }));
    }
  }]);

  return FBHeader;
}(Component), _defineProperty(_class2, "propTypes", {
  avatarUrl: PropTypes.string,
  dateText: PropTypes.any,
  pageName: PropTypes.string,
  rating: PropTypes.number
}), _temp)) || _class);
export default FBHeader;